import {scaleLinear} from 'd3-scale';
import {Colours} from '@learningblocks/storybook-components';

const PERCENTAGE = {
  HALF: 50,
  MIN: 0,
  MAX: 100,
};

function getSelectedPercentage({min, max, value}) {
  return scaleLinear()
    .domain([min, max])
    .range([PERCENTAGE.MIN, PERCENTAGE.MAX])(value);
}

export function getSliderStyle({
  min,
  max,
  value,
  leftPortionColour = Colours.colorSecondaryBlue,
  rightPortionColor = Colours.colorPrimaryTone80,
}) {
  let selectedPercentage = getSelectedPercentage({min, max, value});
  let background = rightPortionColor;
  if (selectedPercentage > PERCENTAGE.HALF) {
    background = `linear-gradient(to right, ${leftPortionColour} ${selectedPercentage}%, ${rightPortionColor} ${
      PERCENTAGE.MAX - selectedPercentage
    }%)`;
  } else {
    background = `linear-gradient(to left, ${rightPortionColor} ${
      PERCENTAGE.MAX - selectedPercentage
    }%,  ${leftPortionColour} ${selectedPercentage}% )`;
  }
  return {background};
}
